<template>
  <div class="center calculator">
    <v-container fluid grid-list-md>
      <v-flex v-bind="{ [`${flex}`]: false }">
    <v-layout row justify-center>

        <v-card flat max-width="500">
          <!--<iframe src="https://juliazhaohomes.com/home-mortgage-calculator" frameborder="0" style="display: block;overflow:hidden;height: 100vh;width: 100vw;"></iframe>-->
          <v-card-title primary-title>
            <div class="center">
              <span class="headline mb-0 pl-2">Mortgage Calculator</span>
            </div>
          </v-card-title>
          <div style="padding-bottom:25px;"></div>
          <div style="min-width:240px;min-height:450px;">
            <v-form v-model="valid">
              <v-text-field
                id="totalAmount"
                v-model="totalAmount"
                :rules="[rules.required]"
                label="Total Amount ($) *"
                required
              ></v-text-field>

              <v-text-field
                id="downPayment"
                v-model="downPayment"
                label="Down Payment ($)"
              ></v-text-field>
              <v-text-field
                id="rate"
                v-model="rate"
                :rules="[rules.required]"
                label="Interest Rate (%) *"
                required
              ></v-text-field>
              <v-text-field
                id="period"
                v-model="period"
                :rules="[rules.required]"
                label="Amortization Period (years) *"
                required
              ></v-text-field>
              <!--<v-btn light @click="back"><v-icon small color="pink">fas fa-chevron-left</v-icon>Back</v-btn>-->
              <v-btn light @click="submit">Calculate</v-btn>
            </v-form>
            <div v-if="result" style="color:green;padding-top:10px;"><p>Monthly Payment:<br/>${{result}}</p></div>
          </div>
          <v-card-text class="back-btn">
            <v-btn small light round @click="back">
              <v-icon small color="pink">fas fa-chevron-left</v-icon>&nbsp;Back
            </v-btn>
          </v-card-text>
      </v-card>
    </v-layout>
      </v-flex>
    </v-container>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import {Utils} from "../utils";

  export default {
        name: "calculator",
      data(){
          return {
            totalAmount: null,
            downPayment: 60000,
            rate: 5,
            period: 30,
            result: null,
            rules: {
              required: value => !!value || ' '
            },
            valid: true
          }
      },
      computed:{
        ...mapState({
          isMobile: state => state.homeStore.isMobile,
          calculatePrice: state => state.homeStore.calculatePrice
        }),
        flex: {
          get(){
            if( this.isMobile ) return 'xs12'
            return 'xs6'
          },
          set(val){

          }
        }
      },
      created(){
          this.totalAmount = this.calculatePrice
      },
      methods: {
        submit: function () {
          if( !this.totalAmount || this.totalAmount <= 0 || !this.rate || !this.period ) return
          if( !this.downPayment ) this.downPayment = 0
          let p = this.totalAmount - this.downPayment
          let r = this.rate / 12 / 100
          let n = this.period * 12
          let rf = Math.pow(1 + r, n)
          let a = (r * rf)
          let b = rf-1
          let f = a/b
          let pf = p*f
          this.result = Utils.getPriceUS((p * ((r * rf) / (rf - 1))), 2)
        },
        back(){
          this.$router.go(-1)
        },
      }
    }
</script>

<style scoped>
@import "calculator.css";
</style>
